<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between margin-bottom-sm list-title">
            <b>短信提醒</b>
            <router-link class="add-btn" to="/organization/message/remindList">提醒记录
            </router-link>
        </div>

        <el-table
            v-loading="loading"
            :data="list"
            border
            header-row-class-name="table-header"
            style="width: 100%; border-radius: 10px">
            <el-table-column
                label="序号"
                type="index"
                width="50">
                <template slot-scope="scope">
                    <div class="table-name">
                        {{ scope.$index + 1 }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="描述" prop="title">
                <template slot-scope="scope">
                    <div class="table-name"> {{ scope.row.title }}</div>
                </template>
            </el-table-column>
            <el-table-column label="可用状态" prop="diss">
                <template slot-scope="scope">
                    <div class="table-name flex flex-direction align-center justify-center">
                        <div :class="scope.row.diss ? 'text-red':'text-green'">{{scope.row.diss ? 'x' : '√'}}</div>
                        <div class="text-red margin-top-xs" v-if="scope.row.diss"> {{ scope.row.error }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="开启状态" prop="state" width="140px">
                <template slot-scope="scope">
                    <div class="table-name">
                        <el-switch v-model="scope.row.state" :active-value="1" :inactive-value="0" @change="(e)=>{return stateChange(e,scope.$index,scope.row)}"></el-switch>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import {zhDate} from "@/utils/utils";
import {checkAutoSendfield, getAutoSendState, setAutoSendState} from "@/api/organiz";

export default {
    name: "list",
    data() {
        return {
            list: [],
            loading: true,
        }
    },
    created() {
        this.$emit('setIndex', [1, 2], '短信提醒')
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        /**
         * `is_auto_send_staff` => '是否自动发送给员工生日提醒 0否1是',
         * `is_auto_send_person` => '是否自动发送给个人会员生日提醒 0否1是',
         * `is_auto_send_company` => '是否自动发送给单位会员成立纪念日提醒 0否1是',
         * `is_auto_send_admin_company` => '是否自动发送给管理员单位会员成立纪念日提醒 0否1是',
         * `is_auto_send_admin_staff_birthday` =>'是否自动发送给管理员员工生日提醒 0否1是',
         * `is_auto_send_admin_birthday` => '是否自动发送给管理员个人会员提醒 0否1是',
         * `is_auto_send_admin_staff` => '是否自动发送给管理员员工入职提醒 0否1是',
         * `is_auto_send_admin_user` => '是否自动发送给管理员会员入会提醒 0否1是',
         */
        async init() {
            this.loading = true
            let _data = await getAutoSendState()
            let _status = _data.data
            let _list = []
            _list.push({
                title: '是否自动发送给员工生日提醒',
                state: _status.is_auto_send_staff,
                name: 'is_auto_send_staff',
                diss: false,
                error: ''
            })
            _list.push({
                title: '是否自动发送给管理员员工生日提醒',
                state: _status.is_auto_send_admin_staff_birthday,
                name: 'is_auto_send_admin_staff_birthday',
                diss: false,
                error: ''
            })
            _list.push({
                title: '是否自动发送给管理员员工入职提醒',
                state: _status.is_auto_send_admin_staff,
                name:'is_auto_send_admin_staff',
                diss: false,
                error: ''
            })
            _list.push({
                title: '是否自动发送给管理员会员入会提醒',
                state: _status.is_auto_send_admin_user,
                name:'is_auto_send_admin_user',
                diss: false,
                error: ''
            })
            _data = await checkAutoSendfield('is_auto_send_person')
            _list.push({
                title: '是否自动发送给个人会员生日提醒',
                state: _status.is_auto_send_person,
                name:'is_auto_send_person',
                diss: _data.status !== 200,
                error: _data.msg
            })
            _list.push({
                title: '是否自动发送给管理员个人会员提醒',
                state: _status.is_auto_send_admin_birthday,
                name:'is_auto_send_admin_birthday',
                diss: _data.status !== 200,
                error: _data.msg
            })
            _data = await checkAutoSendfield('is_auto_send_company')
            _list.push({
                title: '是否自动发送给单位会员成立纪念日提醒',
                state: _status.is_auto_send_company,
                name:'is_auto_send_company',
                diss: _data.status !== 200,
                error: _data.msg
            })
            _list.push({
                title: '是否自动发送给管理员单位会员成立纪念日提醒',
                state: _status.is_auto_send_admin_company,
                name:'is_auto_send_admin_company',
                diss: _data.status !== 200,
                error: _data.msg
            })


            this.loading = false
            this.list = _list
        },
        async stateChange(e, index, row) {
            this.loading = true
            let _data = await setAutoSendState(row.name,e)
            this.loading = false
            if (_data.status === 200) {
                if (row.error && e){
                    this.$message.error('设置成功,状态不可用，请检查配置项')
                }else{
                    this.$message.success('设置成功')
                }
            } else {
                this.list[index].state = e ? 0 : 1
            }
        }
    },
    filters: {
        timer(val) {
            return zhDate(val)
        }
    }

}
</script>

<style lang="scss" scoped>
.warpper {
    background: #fff;
    border-radius: 10px;

    .list-title {
        b {
            font-size: 26px;
            line-height: 34px;
        }

        .add-btn {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #fff;
        }
    }


}
</style>